import { safeLocalStorage } from '@toss/storage';

const STORAGE_KEY = 'quiz.build.proFeatureCoachmark.dismissed.v1';

type DismissedStorage = Record<string, true>;

const parseStorage = (): DismissedStorage => {
  const value = safeLocalStorage.get(STORAGE_KEY);
  if (!value) return {};

  try {
    const parsed = JSON.parse(value);
    if (parsed && typeof parsed === 'object') {
      return parsed as DismissedStorage;
    }
  } catch {
    return {};
  }
  return {};
};

export const buildProFeatureCoachmarkStorage = {
  isDismissed(scopeKey: string): boolean {
    return parseStorage()[scopeKey] === true;
  },

  markDismissed(scopeKey: string): void {
    safeLocalStorage.set(
      STORAGE_KEY,
      JSON.stringify({ ...parseStorage(), [scopeKey]: true }),
    );
  },

  resetDismissed(): void {
    safeLocalStorage.remove(STORAGE_KEY);
  },
};
